/* eslint-disable no-unused-vars */
import React, { useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import * as actions from '../action';
import * as c from '../constant';

function UpdateModal({
  createUpperCaseInput,
  createSelect,
  updateMarriageCertificate,
  showTransaction,
  formData,
  updateList,
  setFormData,
  id,
  updating,
}) {
  const setModal = useContext(ModalContext);

  const handleOnSubmit = (e) => {
    e.preventDefault();

    const args = {
      ...formData
    }

    args.first_name = args.first_name.toUpperCase();
    args.last_name = args.last_name.toUpperCase();

    updateMarriageCertificate(id, args, () => {
      setModal({ isOpen: false });
      showTransaction(id);
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const onSetFormData = () => {
    if (!_.isEmpty(updateList)) {
      const args = {
        ...updateList,
      };
      setFormData(_.pick(args, _.keys(c.FORM_DATA)));
    }
  };

  useEffect(() => {
    onSetFormData();
  }, []);

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label> Document Owner&apos;s Information </label>
          </div>
          <div className="col-6 form-group">
            {createUpperCaseInput({ key: 'husband_first_name', label: 'First Name:' })}
          </div>
          <div className="col-6 form-group">
            {createUpperCaseInput({ key: 'husband_middle_name', label: 'Middle Name:' })}
          </div>
          <div className="col-6 form-group">
            {createUpperCaseInput({ key: 'husband_last_name', label: 'Last Name:' })}
          </div>
          <div className="col-6 form-group">
            {createSelect(
              {
                required: true,
                placeholder: 'Extension Name',
                key: 'extension_name',
                label: 'Extension Name',
              },
              c.EXTENSION_NAMES
            )}
          </div>
          <div className="col-6 form-group">
            {createUpperCaseInput({ key: 'wife_first_name', label: 'First Name:' })}
          </div>
          <div className="col-6 form-group">
            {createUpperCaseInput({ key: 'wife_middle_name', label: 'Middle Name:' })}
          </div>
          <div className="col-6 form-group">
            {createUpperCaseInput({ key: 'wife_last_name', label: 'Last Name:' })}
          </div>
          <div className="col-12 form-group">
            <label> Requestor&apos;s Information </label>
          </div>
          <div className="col-6 form-group">
            {createUpperCaseInput({
              key: 'requestors_first_name',
              label: 'First Name:',
            })}
          </div>
          <div className="col-6 form-group">
            {createUpperCaseInput({
              key: 'requestors_middle_name',
              label: 'Middle Name:',
            })}
          </div>
          <div className="col-6 form-group">
            {createUpperCaseInput({
              key: 'requestors_last_name',
              label: 'Last Name:',
            })}
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={updating}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3"
          >
            <span className="font-weight-bold">
              {updating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>
          </button>
          <button
            disabled={updating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

UpdateModal.propTypes = {
  createUpperCaseInput: PropTypes.instanceOf(Function).isRequired,
  createSelect: PropTypes.instanceOf(Function).isRequired,
  updateList: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  showTransaction: PropTypes.instanceOf(Function).isRequired,
  updateMarriageCertificate: PropTypes.instanceOf(Function).isRequired,
  id: PropTypes.string.isRequired,
  updating: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  updating: api.loading.indexOf(c.EDIT_MARRIAGE) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(UpdateModal);
